import { ExternalLink } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { AccountDeletionPanel } from '@/components/compliance/AccountDeletionPanel'
import { Button } from '@/components/ui/button'

export function PrivacyDataPanel() {
  const { t } = useTranslation('compliance')

  return (
    <section className='overflow-hidden rounded-2xl border border-[#e7e9ef] bg-white shadow-[0px_1px_4px_-4px_rgba(38,45,66,0.05),0px_8px_16px_-4px_rgba(38,45,66,0.1)]'>
      <header className='flex h-16 items-center gap-2 overflow-hidden pb-2 pr-6 pt-6'>
        <div className='flex min-w-0 flex-1 items-center border-l-4 border-[#ff5a1f] px-6 py-1'>
          <h2 className='font-heading text-sm font-semibold leading-[1.2] text-[#171a20]'>
            {t('privacyData.title')}
          </h2>
          <p className='sr-only'>{t('privacyData.subtitle')}</p>
        </div>
        <Button
          variant='ghost'
          className='h-8 gap-2 rounded-xl px-3 py-2 text-sm font-medium leading-none text-[#171a20]'
          asChild
        >
          <Link to='/privacy-policy'>
            <ExternalLink className='size-4' />
            {t('privacyData.viewPolicy')}
          </Link>
        </Button>
      </header>

      <div className='px-6 pb-6 pt-4'>
        <AccountDeletionPanel />
      </div>
    </section>
  )
}

export default PrivacyDataPanel
